function Ctrl($scope, metaTagService) {
  metaTagService.set({
    title: 'What is Bottle Service? | Tablelist',
    description: 'Book VIP bottle service, private tables, and attend exclusive events through Tablelist'
  });
}

Ctrl.$inject = [
  '$scope',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/tableservice/tableserviceCtrl.js